// Packages
import { useSelector } from "react-redux";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SelectField(props) {
  const {
    label,
    required,
    id,
    position,
    value,
    options,
    custom_field_id,
    errors,
    setCustomField,
    custom,
  } = props;
  const elementId = `custom_field_${props.area}_${custom_field_id}`;
  const { t } = useTranslation();
  const doingRequest = useSelector((state) => state.ui.doingRequest);
  const colors = useSelector((state) => state.checkoutStore.colors);

  const defaultColor = "#929292";

  const customStyles = (isError) => ({
    control: (base) => ({
      ...base,
      borderRadius: "6px",
      height: "44px",
      padding: "0 8px",
      fontSize: "14px",
      border: isError ? "2px solid #ed2c2c !important;" : "",
      backgroundColor: isError ? "#feeded !important" : "white",
    }),
    placeholder: (base) => ({
      ...base,
      color: defaultColor,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: defaultColor,
      padding: "8px",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({
      ...base,
      padding: "4px 8px",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? defaultColor
        : state.isFocused
          ? "#f0f0f0"
          : "#fff",
      color: state.isSelected ? colors.text_color : "#000",
      padding: "8px 12px",
      cursor: "pointer",
    }),
  });

  return (
    <div className={`col-12 mb-3 form-group`}>
      <div
        className={`input-placeholder floating-label-wrap ${
          errors[elementId] ? "error-div-highlight" : ""
        }`}
      >
        <label htmlFor={elementId} className="label-checkout">
          <span
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(label, {
                ADD_ATTR: ["target"],
              }).replace(/<\/?p>/g, ""),
            }}
          />
          {required ? " *" : ""}
        </label>
        <div>
          <Select
            styles={customStyles(errors[elementId])}
            style={{ height: "40px" }}
            classNamePrefix="custom-select"
            id={elementId}
            disabled={doingRequest}
            options={options}
            onChange={(row) =>
              setCustomField(elementId, custom_field_id, row.value, props.area)
            }
            value={
              (value != null &&
                options.find((current) => current.value === value)) ||
              ""
            }
          />
        </div>
      </div>
      <div
        className={`field-error ${errors[elementId] ? "" : "hidden-error"}`}
        style={{
          display: errors[elementId] ? "flex" : "",
          alignItems: "center",
        }}
      >
        <FontAwesomeIcon
          icon={faCircleExclamation}
          style={{ paddingRight: "2px" }}
          size="sm"
          fixedWidth
        />
        {errors[elementId] && t(errors[elementId])}
      </div>
    </div>
  );
}

export default SelectField;
